import React, { useState } from 'react';

import moment from 'moment';

import { withStyles } from '@mui/styles';

import { ListItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded';

import Loader from '../../Loader';
import TrplSelect from '../../TrplControls/TrplSelect';

import { Link } from 'react-router-dom';

import styles from './ContactsStyles.js';

import InfiniteScroll from "react-infinite-scroll-component";
import { SELECT_PLACEHOLDER } from '../../../constants';
import { clearHtml } from '../../../utils';

export const CHECKBOX_ALL = -1;
export const ALL_CATEGORIES = -2;

export default withStyles(styles)(
  ({
    subs,
    account,
    classes,
    subValue,
    subsData,
    getDraftMsg,
    contactsList,
    selectedContact,
    onContactSelect,
    contactsIsLoaded,
    channelConceptTo,
    onSubSelectChange,
  }) => {
  const [searchValue, setSearchValue] = useState('');
  const [items, setItems] = useState(20);

  const selectedContactId = selectedContact ? selectedContact.id : null;

  const subValues = [
    {
      title: 'All',
      value: CHECKBOX_ALL,
    },
    {
      title: `All (${contactsList.length})`,
      value: ALL_CATEGORIES,
    }
  ];

  if (subs && subs.nodes)
  Object.keys(subs.nodes).forEach(concept => {
    let sub = subs.nodes[concept];
    if (subsData[sub.id])
    subValues.push({
      title: `${sub.title} (${subsData[sub.id].count})`,
      value: sub.id,
    })
  });

  const diffTime = (timestamp, userOffset = 0) => {
    const localOffset = moment().utcOffset() * 60 * 1000; // Convert minutes to milliseconds

    // Apply the user-provided offset if it's different from the local offset
    const offsetToUse = userOffset || localOffset;

    // Calculate the adjusted current time based on the offset
    const adjustedCurrentTime = moment().utcOffset(offsetToUse).valueOf();
    const diffInMilliseconds = adjustedCurrentTime - moment(timestamp).utcOffset(offsetToUse).valueOf();

    // Calculate days, hours, minutes, and seconds
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInSeconds = Math.floor(diffInMilliseconds / 1000);

    // Determine the closest time unit
    let elapsedTime;
    if (diffInDays >= 1) {
      elapsedTime = `${diffInDays}d`;
    } else if (diffInHours >= 1) {
      elapsedTime = `${diffInHours}h`;
    } else if (diffInMinutes >= 1) {
      elapsedTime = `${diffInMinutes}m`;
    } else {
      elapsedTime = `${diffInSeconds}s`;
    }

    return `~${elapsedTime}`;
  };

  const checkContact = (contact) => {
    if (contact.contactTitle.toLowerCase().indexOf(searchValue.toLowerCase()) === -1 || !subValue.length) {
      return null;
    }

    if (subValue.some(subVal => subVal < 0) || contact.ancestors.some(anc => subValue.includes(anc))) {
      return contact;
    }

    return null;
  }

  let filtered;
  let hasMoreData = contactsList.length ? true : false;
  let contacts = contactsList.filter(checkContact);

  filtered = contacts.slice(0, items);
  hasMoreData = contacts.length > filtered.length ? true : false;

  const fetchMoreData = () => {
    setTimeout(() => {
      setItems(items + 20);
    }, 100);
  };

  const setScrollToTop = () => {
    const talksDialog = document.querySelector('.talks-dialog-list');
    if (talksDialog) talksDialog.scrollTop = 0;
  };

  return (
    <div className={classes.contactListContainer}>
      <div className={`talks-search-subs-container ${classes.searchAndSubsContainer}`}>
        <div className={classes.contactSearchContainer} style={{ display: `${'flex'}` }}>
          <input
            label="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setScrollToTop();
            }}
            placeholder="Search"
            className={classes.contactSearchInput}
          />

          {searchValue ? (
            <ClearIcon
              onClick={() => {
                setSearchValue('');
                setScrollToTop();
              }}
              className={classes.contactSearchInputClear} />
          ) : null}
        </div>

        {(subs.nodes && Object.keys(subs.nodes).length !== 0) ? (
          <div className={classes.contactSearchContainer} style={{ marginBottom: '10px' }}>
            <TrplSelect
              multiple
              margin="none"
              MenuProps={{
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null
              }}
              placeholder={subValue.length ? false : 'select a group'}
              complicatedValues
              values={subValues}
              onChange={(e) => {
                onSubSelectChange(e);
                setScrollToTop();
              }}
              value={subValue.length ? subValue : [SELECT_PLACEHOLDER]}
            />
          </div>
        ) : null}
      </div>

      {contactsIsLoaded ? (
      <div id='talks-list' className={`talks-dialog-list ${classes.contactList}`}>
        <InfiniteScroll
          dataLength={items}
          next={fetchMoreData}
          hasMore={hasMoreData}
          loader={
            filtered.length &&
            <div className={classes.loaderContainer}>
              <Loader />
            </div>
          }
          scrollableTarget='talks-list'
          style={{
            overflow: 'hidden',
          }}
        >
          {filtered.length ? (
            filtered.map((contact, index) => {
              const linkParam = `contact_id=${contact.contact_info.contact_id}${
                contact.type ? `&tab=${contact.type.toLowerCase()}` : ''
              }`;

              const isContactMuted =  localStorage.getItem(`chat.notifications.${contact.contact_info.contact_id}`) === 'muted';

              const location = window.location.href;
              let linkUrl = `/chat?${linkParam}`;
              
              if (location.split('/').includes('addon')) {
                linkUrl = `/addon/chat/${channelConceptTo}?${linkParam}`;
              }

              let isContactSelected;
              if (selectedContact) isContactSelected = selectedContactId === contact.contact_info.contact_id;

              const contactNoAuth = contact.contact_info.no_auth;

              const contactClass = isContactSelected ? `${classes.contactSelected}` : null;

              const contactLastMsg =
                contact.body && contact.body.length > 50
                  ? contact.body.substr(0, 50)
                  : contact.body
                  ? contact.body
                  : '';

              const draftMsg = selectedContactId !== contact.contact_info.contact_id
                && getDraftMsg(contact.contact_info.contact_id);

              const currentMessage = draftMsg ? draftMsg : contactLastMsg;

              let onListItemClick;
              const contactGeneralIndex = contactsList.indexOf(contact);

              onListItemClick = () => onContactSelect(contact.contact_info.contact_id, contactGeneralIndex, true);

              const contactLastMsgTime = contact.timestamp ? diffTime(contact.timestamp, account.offset) : null;

              return (
                <Link
                  key={contactGeneralIndex}
                  to={linkUrl}
                  className={`${classes.contactLink} ${isContactSelected ? 'talks-page-dialog-selected' : ''}`}
                >
                  <ListItem
                    onClick={onListItemClick}
                    className={`${!contact.isSeen ? classes.contactNotSeen : ''} ${classes.contact} ${contactClass}`}
                    button
                  >
                    <div className={classes.contactRecipientContainer}>
                      <div style={{display: 'flex'}}>
                        <b
                          className={`${classes.contactRecipient} ${contactNoAuth ? classes.contactNoAuthRecipient : ''}`}
                        >
                          {contact.contactTitle}
                        </b>
                        {isContactMuted ?
                          <VolumeOffRoundedIcon
                            style={{
                              fontSize: '15px',
                              color: '#4c4c4c',
                              marginLeft: '5px',
                              opacity: 0.5
                            }}
                          />
                        : null}
                      </div>
                      {!draftMsg && (
                        <span
                          className={`${classes.contactRecipientTime} ${
                            isContactSelected && classes.contactTextSelected
                          }`}
                        >
                        {contactLastMsgTime}
                      </span>
                      )}
                    </div>

                    <div className={classes.contactMsgContainer}>
                      <i
                        className={`${classes.contactLastMsgIcon} ${
                          contact.type === 'SMS'
                            ? 'fas fa-mobile-alt'
                            : contact.type === 'TELEGRAM'
                            ? 'fab fa-telegram-plane'
                            : contact.type === 'FACEBOOK'
                            ? 'fab fa-facebook-f'
                            : contact.type === 'WEB'
                            ? 'fas fa-globe'
                            : 'fas fa-envelope'
                        } ${isContactSelected ? classes.contactTextSelected : ''}`}
                      />

                      {!contact.incoming && contactLastMsg.length ? (
                        <span className={classes.contactYouText}>You: </span>
                      ) : null}

                      {currentMessage ?
                        <div
                          className={`${classes.contactMsg} ${isContactSelected ? classes.contactTextSelected : ''}`}
                          dangerouslySetInnerHTML={{ __html: draftMsg ? ' Draft: ' + clearHtml(draftMsg) : clearHtml(contactLastMsg) }}
                        />
                        : null
                      }

                      {contact.unseen.total > 0 ? (
                        <div
                          className={classes.contactMsgUnseenCount}
                          style={{ background: `${isContactMuted ? '#c4c4c4' : 'red'}` }}
                        >
                          {contact.unseen.total}
                        </div>
                      ) : null}
                    </div>
                  </ListItem>
                </Link>
              );
            })
          ) : null}
        </InfiniteScroll>
      </div>
      ) : 
      <div className={classes.loaderContainer}>
        <Loader />
      </div>}
    </div>
  );
});
